import { AspectRatio, Box, Flex, HStack, Text, VStack } from '@chakra-ui/react'
import Image from 'next/image'

const ClinicallyResult = () => {
  return (
    <VStack mt={16} alignItems="center" w="100%">
      <VStack data-aos="fade-up" w="100%">
        <Text
          textTransform="uppercase"
          textStyle="docMainTitle"
          textAlign="center"
        >
          CLINICALLY PROVEN RESULTS
        </Text>
        <Text textTransform="uppercase" textStyle="docInfo" textAlign="center">
          FROM THE KOREA INSTITUTE OF DERMATOLOGY
        </Text>

        <AspectRatio
          mt={5}
          w={{
            base: '90%',
            sm: '480px',
            md: '600px'
          }}
          ratio={600 / 263}
          position="relative"
        >
          <Image
            src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/clinically-result-1710996976430.png"
            alt="clinnically result"
            fill
          />
        </AspectRatio>
      </VStack>

      <Flex
        data-aos="fade-up"
        justifyContent="space-between"
        alignItems="center"
        flexDir={{
          base: 'column',
          md: 'row'
        }}
        w={{
          base: '100%',
          md: 600
        }}
      >
        <Text
          textTransform="uppercase"
          textStyle="docMainTitle"
          textAlign="center"
          w={{
            base: '100%',
            md: 200
          }}
        >
          WRINKLE REDUCTION
        </Text>
        <AspectRatio
          mt={5}
          w={{
            base: '90%',
            sm: '480px',
            md: '400px'
          }}
          ratio={400 / 172}
          position="relative"
        >
          <Image
            src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/wrinkle-reduction-1710997468391.png"
            alt="wrinkle reduction"
            fill
          />
        </AspectRatio>
      </Flex>

      <VStack data-aos="fade-up" mt={4} w="100%">
        <Text
          textTransform="uppercase"
          textStyle="docMainTitle"
          textAlign="center"
        >
          CLINICAL PHOTO OF PORE IMPROVEMENT
        </Text>

        <VStack mt={3} alignItems="center" w="100%">
          <AspectRatio
            mt={5}
            w={{
              base: '90%',
              sm: '480px',
              md: '600px'
            }}
            ratio={600 / 184}
            position="relative"
          >
            <Image
              src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/pore-improvement-1710997840724.png"
              alt="pore improvement"
              fill
            />
          </AspectRatio>
        </VStack>
      </VStack>

      <Flex
        data-aos="fade-up"
        justifyContent="space-between"
        alignItems="center"
        flexDir={{
          base: 'column-reverse',
          md: 'row'
        }}
        mt={5}
        w={{
          base: '100%',
          md: 600
        }}
      >
        <AspectRatio
          mt={5}
          w={{
            base: '90%',
            sm: '480px',
            md: '400px'
          }}
          ratio={400 / 172}
          position="relative"
        >
          <Image
            src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/pore-improvement-nose-1710997706376.png"
            alt="pore improvement nose"
            fill
          />
        </AspectRatio>
        <Text
          textTransform="uppercase"
          textStyle="docMainTitle"
          textAlign="center"
          w={200}
        >
          PORE REDUCTION
        </Text>
      </Flex>

      <Flex
        data-aos="fade-up"
        flexDirection="column"
        alignItems="center"
        mt={5}
        w="100%"
      >
        <AspectRatio
          mt={5}
          w={{
            base: '90%',
            sm: '480px',
            md: '600px'
          }}
          ratio={600 / 354}
          position="relative"
        >
          <Image
            src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/skin-improvement-1710998261906.png"
            alt="skin improvement"
            fill
          />
        </AspectRatio>
      </Flex>

      <Box
        mt={12}
        display="flex"
        justifyContent="center"
        alignItems="center"
        bg="#F9F9FB"
        w="100%"
      >
        <VStack
          w={{
            base: '100%',
            md: 600
          }}
          alignItems="center"
        >
          <Text
            textTransform="uppercase"
            textStyle="docMainTitle"
            textAlign="center"
            data-aos="fade-up"
          >
            CLINICAL PHOTO OF <br />
            DECREASED SKIN TEMPERATURE
          </Text>
          <VStack data-aos="fade-up" mt={3} alignItems="center" w="100%">
            <AspectRatio
              mt={5}
              w={{
                base: '90%',
                sm: '480px',
                md: '600px'
              }}
              ratio={600 / 310}
              position="relative"
            >
              <Image
                src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/skin-temperature-1710998387276.png"
                alt="skin temperature"
                fill
              />
            </AspectRatio>

            <Text
              w={{
                base: '90%',
                sm: '480px',
                md: '600px'
              }}
              textStyle="docInfo"
              textAlign="right"
            >
              *Subject number: 1597 Clinical photos
            </Text>
          </VStack>
          <Text
            data-aos="fade-up"
            textTransform="uppercase"
            textStyle="docMainTitle"
            textAlign="center"
            mt={4}
            w={{
              base: '90%',
              sm: '480px',
              md: '600px'
            }}
          >
            EFFECTS OF LOWERING THE TEMPERATURE OF THE CHEEK AND NECK AREA
          </Text>
          <VStack data-aos="fade-up" mt={3} alignItems="center" w="100%">
            <AspectRatio
              mt={5}
              w={{
                base: '90%',
                sm: '480px',
                md: '600px'
              }}
              ratio={600 / 310}
              position="relative"
            >
              <Image
                src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/skin-temperature-cheek-1710998387275.png"
                alt="skin temperature cheek"
                fill
              />
            </AspectRatio>

            <Text
              w={{
                base: '90%',
                sm: '480px',
                md: '600px'
              }}
              textStyle="docInfo"
              textAlign="right"
            >
              *Subject number: 1958 Clinical photos
            </Text>
          </VStack>
          <VStack data-aos="fade-up" mt={3} alignItems="center" w="100%">
            <AspectRatio
              mt={5}
              w={{
                base: '90%',
                sm: '480px',
                md: '600px'
              }}
              ratio={600 / 378}
              position="relative"
            >
              <Image
                src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/control-sebum-1710999019872.png"
                alt="control sebum"
                fill
              />
            </AspectRatio>
          </VStack>
          <VStack data-aos="fade-up" mt={3} alignItems="center" w="100%">
            <AspectRatio
              mt={5}
              w={{
                base: '90%',
                sm: '480px',
                md: '600px'
              }}
              ratio={600 / 922}
              position="relative"
            >
              <Image
                src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/skin-effect-1710999019875.png"
                alt="skin effect"
                fill
              />
            </AspectRatio>
          </VStack>
        </VStack>
      </Box>
    </VStack>
  )
}

export default ClinicallyResult
